import BaseListagem from "components/BaseListagem";
import ItemNotaFiscalEntrada from "model/suprimentos/ItemNotaFiscalEntrada";
import { FilterMatchMode, FilterOperator } from "primereact/api";
import { Column } from "primereact/column";
import { DataTableFilterMeta } from "primereact/datatable";
import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import ExecucaoPlanoQualidadeService from "service/qualidade/ExecucaoPlanoQualidadeService";
import RecebimentoService from "service/qualidade/RecebimentoService";
import { converterDataHora } from "utils/convert";
import { DateMatchModeOptions, IdMatchModeOptions, ListMatchModeOptions, NumberMatchModeOptions, ProdutoFilterTemplate, TextMatchModeOptions, dateFilterTemplate, decimalFilterTemplate, filterApplyTemplate, statusFilterTemplate } from "utils/filterUtils";
import saveAs from 'file-saver';
import { Button } from "primereact/button";
import { useToastContext } from "components/alert/ToastContext";
import UsuarioLogadoService from "service/usuario/UsuarioLogadoService";
import { Dialog } from "primereact/dialog";
import ReportEdit from "components/reports/ReportEdit";
import Produto from "model/administracao/cadastro/produto/Produto";

const recebimentoService = new RecebimentoService();
const execucaoPlanoQualidadeService = new ExecucaoPlanoQualidadeService();
const usuarioLogadoService = new UsuarioLogadoService();

export default function RecebimentoListagem() {

    const [queryParameters] = useSearchParams();

    const [titulo, setTitulo] = useState<string>('Recebimento');
    const [visibleDialogRelatorio, setVisibleDialogRelatorio] = useState(false);
    const [editaRelatorios, setEditaRelatorios] = useState(false);

    const [produtos, setProdutos] = useState<Produto[]>([]);

    const { msgSucesso, msgErro, msgAlerta } = useToastContext();

    useEffect(() => {
        usuarioLogadoService.getAcoesUsuarioLogado().then((resposta) => {
            if (usuarioLogadoService.usuarioTemAcao(resposta, "RELATORIO_COMPOSICAO_ESTAGIO_OP")) {
                setEditaRelatorios(true);
            }
        }).catch((erro) => {
            console.log(erro);
        });

        recebimentoService.getProdutos().then(lista => {
            setProdutos(lista);
        }).catch(err => {
            console.log(err);
        });
    }, [])

    const emitirRelatorio = (rowData: ItemNotaFiscalEntrada) => {
        recebimentoService.emitirRelatorio(rowData.id).then((response) => {
            const file = new Blob([response], { type: 'application/pdf' });
            saveAs(file, (rowData.produto?.codigoInterno || rowData.produto?.nome) + " - " + rowData.lote + ".pdf");
        }).catch((err) => {
            console.log(err);
            msgErro("Erro", 'Erro ao gerar relatório');
        });
    }

    const getBotoesExtra = () => {
        let botoesExtra = [];
        if (editaRelatorios) {
            botoesExtra.push(
                <Button key="relatorio" label="Editar relatório" onClick={() => setVisibleDialogRelatorio(true)} />
            );
        }
        return botoesExtra;
    }

    const defaultFilters: DataTableFilterMeta = {
        produto: {
            constraints: [
                {
                    value: '',
                    matchMode: FilterMatchMode.EQUALS,
                }
            ],
            operator: FilterOperator.AND
        },
        produtoNome: {
            constraints: [
                {
                    value: '',
                    matchMode: FilterMatchMode.STARTS_WITH,
                }
            ],
            operator: FilterOperator.AND
        },
        lote: {
            constraints: [
                {
                    value: '',
                    matchMode: FilterMatchMode.STARTS_WITH,
                }
            ],
            operator: FilterOperator.AND
        },
        quantidade: {
            constraints: [
                {
                    value: null,
                    matchMode: FilterMatchMode.EQUALS,
                }
            ],
            operator: FilterOperator.AND
        },
        dataGeracao: {
            constraints: [
                {
                    value: null,
                    matchMode: FilterMatchMode.EQUALS,
                }
            ],
            operator: FilterOperator.AND
        },
        status: {
            constraints: [
                {
                    value: null,
                    matchMode: FilterMatchMode.IN,
                }
            ],
            operator: FilterOperator.AND
        },
    }

    return (
        <>
            <Dialog visible={visibleDialogRelatorio}
                onHide={() => setVisibleDialogRelatorio(false)}
                header="Relatórios"
                style={{ width: "50%" }}
            >
                <ReportEdit nomeAcao="RELATORIO_EXECUCAO_PLANO_RECEBIMENTO" titulo="Relatório de recebimento" testarRelatorio={() => { }} style={{ marginBottom: 10 }} />
            </Dialog>
            <BaseListagem
                ordenacao="execucaoPlanoQualidade.dataGeracao,DESC"
                service={recebimentoService} urlService="/recebimento"
                tituloPagina={titulo}
                buttonsExtra={getBotoesExtra()}
                showRemoveButton={false} showNewButton={false}
                defaultFilters={defaultFilters} showClearFilterButton
                nome="recebimento"
            >

                <Column field="produto.codigo" header="Produto" filter showFilterOperator={false} showAddButton={false} filterPlaceholder="Escreva o filtro" filterField="produto"
                    filterMatchModeOptions={IdMatchModeOptions} filterApply={filterApplyTemplate} filterElement={(options) => <ProdutoFilterTemplate options={options} opcoes={produtos} />} />
                <Column field="produto.nome" header="Nome" filter showFilterOperator={false} showAddButton={false} filterPlaceholder="Escreva o filtro"
                    filterMatchModeOptions={TextMatchModeOptions} filterApply={filterApplyTemplate} filterField="produtoNome" />
                <Column field="lote" header="Lote" filter showFilterOperator={false} showAddButton={false} filterPlaceholder="Escreva o filtro"
                    filterMatchModeOptions={TextMatchModeOptions} filterApply={filterApplyTemplate} />
                <Column field="quantidade" header="Quantidade" filter showFilterOperator={false} showAddButton={false} filterElement={decimalFilterTemplate}
                    filterMatchModeOptions={NumberMatchModeOptions} filterApply={filterApplyTemplate} />
                
                <Column field="execucaoPlanoQualidade.dataGeracao" header="Geração" body={(rowData) => converterDataHora(rowData?.execucaoPlanoQualidade?.dataGeracao)} filter showFilterOperator={false} showAddButton={false}
                    filterMatchModeOptions={DateMatchModeOptions} filterApply={filterApplyTemplate} filterElement={dateFilterTemplate} filterMenuStyle={{zIndex: 50}} filterField="dataGeracao" />
                <Column field="execucaoPlanoQualidade.status" header="Status" body={(rowData) => execucaoPlanoQualidadeService.getStatusLabel(rowData?.execucaoPlanoQualidade?.status||"")}
                    filter showFilterOperator={false} showAddButton={false} filterMatchModeOptions={ListMatchModeOptions} filterField="status"
                    filterApply={filterApplyTemplate} filterElement={(options) => statusFilterTemplate(options, execucaoPlanoQualidadeService.getListaStatusFilter())} />

                <Column body={(rowData) => <Button label="Relatório" onClick={() => emitirRelatorio(rowData)} />} />
            </BaseListagem>
        </>

    )
}